module.exports = __webpack_public_path__ + "img/emptycart.7fc99eac.png";